<span
  *ngIf="getRefundedCount()"
  [title]="'order.refunded-count' | translate : { count: getRefundedCount() }"
>
  <clr-icon shape="redo" class="is-solid" dir="down"></clr-icon>
</span>
